<div class="hide">
  <div id="{{ configuration['content']['htmlDetachSelectorId'] }}" class="ng-modal-container">
    <ng-content select="[modalContent]"></ng-content>
  </div>
</div>

